import { sortMembersByType } from '@atlaskit/teams-client';
import { type TeamMembership } from '@atlaskit/teams-client/types';

import type { TeamAppState as TeamState } from '../../types';

export const inviteMemberState = (
	teamState: TeamState,
	newMemberships: TeamMembership[],
): TeamState => {
	const { teamAgents } = teamState;

	const memberIds = new Set(newMemberships.map(({ membershipId }) => membershipId.memberId));

	const existingMembers = teamAgents.members.filter((member) => {
		return !memberIds.has(member.membershipId.memberId);
	});

	const finalMembers = sortMembersByType(newMemberships.concat(existingMembers));

	return {
		...teamState,
		teamAgents: {
			...teamState.teamAgents,
			teamId: teamState.teamAgents.teamId,
			hasLoaded: true,
			hasError: false,
			isLoading: false,
			errorType: null,
			members: finalMembers,
		},
	};
};
